var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisqualifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49993 7C5.41131 7 7 5.41471 7 3.5C7 1.58866 5.40779 0 3.49641 0C1.58181 0 0 1.58866 0 3.5C0 5.41471 1.58518 7 3.49993 7ZM3.49671 4.01477C3.31472 4.01477 3.21531 3.90833 3.20828 3.72635L3.16026 2.03154C3.15337 1.84268 3.29744 1.70901 3.49305 1.70901C3.68528 1.70901 3.83272 1.84619 3.82598 2.03491L3.77781 3.72664C3.77093 3.91184 3.66801 4.01491 3.49656 4.01491M3.49656 5.27767C3.29744 5.27767 3.11209 5.11984 3.11209 4.90697C3.11209 4.69409 3.29407 4.53656 3.49656 4.53656C3.69553 4.53656 3.88074 4.69087 3.88074 4.90697C3.88074 5.12321 3.69202 5.27767 3.49656 5.27767Z",
    fill: "#FF0000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisqualifiedIcon);
export default __webpack_public_path__ + "static/media/DisqualifiedIcon.0259d45a7542363d7d98c596ece870fe.svg";
export { ForwardRef as ReactComponent };